import { IconArrowsSplit2 } from '@tabler/icons-react'
import type { JSX } from 'react'

// The one glyph for "shown on a condition": on conditional sections, spans
// and observation nodes alike.
export function ConditionalBranchIcon({
  className,
}: {
  className?: string
}): JSX.Element {
  return <IconArrowsSplit2 className={className ?? 'size-3'} aria-hidden />
}
